import React from "react";
import "./palam_button.scss";

class PalamToggleButton extends React.PureComponent {
    render(){
        let { children, isActive, ...rest } = this.props

        let cssClass="palam-toggle-button";
        cssClass += isActive?" active":"";
        return(
            <button className={cssClass} {...rest}>{children}</button>
        );
    }
}

export default PalamToggleButton